module.exports = __webpack_public_path__ + "img/ctrl-givens-stub-mid-+.a4413859.svg";